import { Form } from 'react-bootstrap'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
//import MandatoryField from '../../MandatoryField/MandatoryField'


const PartsInWashingProcess = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    const [groupByTarget, setGroupByTarget] = useState(false)

    const updateCheckboxAndRadioProperty = (event, name) => {
        switch (name) {
            case 'byOffice':
                setGroupByTarget(false)
                setFormData(prev => ({
                    ...prev,
                    groupBy: name
                    }))
                break
            case 'byTarget':
                setGroupByTarget(true)
                setFormData(prev => ({
                    ...prev,
                    groupBy: name
                    }))
                break
            default:
        }
    }

    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Label className="d-block">{t('reportConfig:groupBy')}</Form.Label>
                <Form.Check
                    inline
                    type="radio"
                    id="groupByOffice"
                    name="groupBy"
                    label={t('reportConfig:groupByOffice')}
                    checked={!groupByTarget}
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'byOffice')}
                />
                <Form.Check
                    inline
                    type="radio"
                    id="groupByTarget"
                    name="groupBy"
                    label={t('reportConfig:groupByTarget')}
                    checked={groupByTarget}
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'byTarget')}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
                <Form.Control
                    name="emailAddress"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        emailAddress: e.target.value
                    }))}
                    value={formData.emailAddress || ''}
                    isInvalid={formErrors && formErrors.emailAddress}
                    autoComplete="email" />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            {/*<MandatoryField />*/}
        </div>
    )
}
export default PartsInWashingProcess